import bFormFile from './form-file.vue';

export default bFormFile;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-file/form-file.js
// module id = 365
// module chunks = 1